/**
 * 公开 API - 活动议程
 */

import { httpGet } from '@/services/http';

export interface PublicAgenda {
  id: number;
  event_id: number;
  time: string;
  end_time?: string;
  title: string;
  title_en?: string;
  description?: string;
  description_en?: string;
  location?: string;
  location_en?: string;
  speaker_id?: number;
  speaker_name?: string;
  speaker_title?: string;
  speaker_institution?: string;
  sort_order?: number;
}

/** GET /api/public/events/:eventId/agendas - 获取活动的议程列表 */
export async function getPublicEventAgendas(eventId: number): Promise<PublicAgenda[]> {
  try {
    const data = await httpGet<PublicAgenda[]>(`/public/events/${eventId}/agendas`);
    return data || [];
  } catch (error) {
    console.error('获取活动议程失败:', error);
    return [];
  }
}
